<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu
      activeNav="Attendees"
      childName="Emails to Attendees"
    ></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading v-if="event" title="Email Attendees"></heading>
        <button @click="toggleTemplate = true" class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Email Attendees
        </button>
        <div v-if="!toggleTemplate">
          <div class="toggle-email-table">
            <h4
              @click="toggleLink('sent')"
              :style="{ marginRight: '20px', cursor: 'pointer' }"
              :class="{ active: this.emails.sent }"
            >
              Emails Sent ({{ emails.sent_quantity }})
            </h4>
            |
            <h4
              @click="toggleLink('scheduled')"
              :style="{ marginLeft: '20px', cursor: 'pointer' }"
              :class="{ active: this.emails.scheduled }"
            >
              Scheduled Emails ({{ emails.scheduled_quanitity }})
            </h4>
          </div>
          <table>
            <thead>
              <td>Subject</td>
              <td>Receipients</td>
              <td>Date</td>
              <td></td>
            </thead>

            <tbody v-if="emails.sent">
              <tr v-for="(ticket, index) in tickets" :key="index">
                <td :style="{ width: 'unset' }" data-label="Subject">{{ event.title }}</td>
                <td data-label="Recipients">{{ tickets.sold }}</td>
                <td data-label="Date">{{ date }}</td>
                <td data-label="Action">
                  <img class="trash" src="@/assets/img/trash.svg" />
                </td>
              </tr>
            </tbody>

            <tbody v-if="emails.scheduled">
              <tr v-for="(ticket, index) in tickets" :key="index">
                <td :style="{ width: 'unset' }" data-label="Subject">{{ event.title }}</td>
                <td data-label="Recipients">{{ tickets.sold }}</td>
                <td data-label="Date">
                  <input type="date" name id />
                </td>
                <td data-label="Action">
                  <img class="trash" src="@/assets/img/trash.svg" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else >
          <email-template :event.sync="event" @cancel="toggleTemplate = false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import AttendeeEmailTemplate from "@/components/AttendeeEmailTemplate.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
    "email-template": AttendeeEmailTemplate,
  },
  data() {
    return {
      toggleTemplate: false,
      event: {},
      tickets: {
        total: 100,
        sold: 50,
      },
      date: moment().calendar("L"),
      progress: "0%",
      emails: {
        scheduled: true,
        sent: false,
        sent_quantity: 0,
        scheduled_quanitity: 0
      },
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
    };
  },
  created() {},
  methods: {
    toggleLink(param) {
      if (this.emails.scheduled === true && param === "sent") {
        this.emails.scheduled = false;
        this.emails.sent = true;
      } else if (this.emails.sent === true && param === "scheduled") {
        this.emails.scheduled = true;
        this.emails.sent = false;
      }
    },
  },
};
</script>

<style lang="scss">
.toggle-email-table {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.active {
  color: #fba500;
}
</style>
